
import { Vue, Component, Prop } from 'vue-property-decorator'
import PersonalDataFormPanel from './PersonalDataFormPanel.vue'
import { PersonalDataFormType, PersonalDataFormFieldsTranslations } from './types'
import { ApiValidationErrors } from '~/utils/apolloErrors'

@Component({
  components: {
    PersonalDataFormPanel,
  },
})
export default class PersonalDataFormsAccordion extends Vue {
  @Prop(Array) readonly formTypes!: PersonalDataFormType[]
  @Prop(Object) readonly prefill?: {
    firstname: string
    lastname: string
    email: string
  } | null

  @Prop(Boolean) readonly isLoading!: boolean

  @Prop({ type: Object, required: true })
  translations!: PersonalDataFormFieldsTranslations

  @Prop({ type: Object, default: () => ({}) })
  readonly apiErrors!: ApiValidationErrors

  activeIndex: number | null = null

  togglePanel(index: number) {
    this.activeIndex = this.activeIndex === index ? null : index
  }
}
